<template>
    <div class="dashboard-nav-bar-wrapper">
        <div class="dashboard-nav-bar">
            <img src="/applogo.png" width="250" height="32">
            <slot>dashboard navbar</slot>
        </div>
    </div>
</template>



<script>
export default {
    name: 'DashboardNavBar',
    template: '<dashboard-nav-bar />',
    data (){
        return{

        }
    },

    computed:{

    },

    methods:{

    },

    created(){

    },
    
    mounted(){

    }

}
</script>




<style>
.dashboard-nav-bar-wrapper{
    position: relative;
}
.dashboard-nav-bar{
    display: flex;
    position: fixed;
    background: #ccc;
    padding: 1rem;
}

</style>
